<template>


 <div
  v-if="property?.property_manager"
  class="tw-w-full tw-max-w-xl tw-mx-auto  tw-border  tw-p-6 md:tw-p-8 tw-flex tw-flex-col tw-items-center tw-text-center tw-gap-3"
style="border-radius: var(--rounded); border-color: var(--c-border)">
  <!-- Property Manager Photo -->
  <div class="tw-mb-2">
    <div
      class="tw-h-20 tw-w-20 tw-overflow-hidden tw-rounded-full tw-border-4 tw-shadow-md"
      style="border-color: var(--c-border)"
    >
      <library-image
        v-if="property.property_manager.image"
        :src="property.property_manager.image"
        :alt="`${property.property_manager.name} ${property.property_manager.surname}`"
        :title="`${property.property_manager.name} ${property.property_manager.surname}`"
        image-class="tw-h-full tw-w-full tw-object-cover"
        :design-width="80"
        :design-height="80"
      />
      <!-- Fallback avatar -->
      <div v-else class="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-bg-gray-200">
        <svg class="tw-h-10 tw-w-10 tw-text-gray-400" fill="currentColor" viewBox="0 0 20 20">
          <path
            fill-rule="evenodd"
            d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
    </div>
  </div>

  <!-- Property Manager Name -->
  <div class="tw-mb-1">
    <h5 class="tw-font-semibold tw-text-gray-900">
      {{ property.property_manager.name }} {{ property.property_manager.surname }}
    </h5>
    <p class="tw-text-sm tw-text-gray-600">Property Manager</p>
  </div>

  <!-- Property Manager Email -->
  <div class="tw-mb-2">
    <a
      :href="`mailto:${property.property_manager.email}`"
      class="tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-blue-600 hover:tw-text-blue-800 tw-transition-colors"
    >
      <svg class="tw-h-4 tw-w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M3 8l7.89 7.89a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
      {{ property.property_manager.email }}
    </a>
  </div>

  <!-- Contact Button -->
  <a
    :href="property?.property_manager?.phone ? `tel:${property.property_manager.phone}` : `mailto:${property.property_manager.email}`"
    class="n-primary tw-w-full tw-max-w-xs tw-text-center"
  >
    Contact Manager
  </a>
</div>

</template>

<script lang="ts">

import { mapActions } from 'pinia';
import { ROUTES } from '~/constants/ui.constants';
import { usePropertiesStore } from '~/units/properties/stores';
import type { Component } from '~/types';
import { ComponentMixin } from '~/mixins/component.mixin';
import { PropertyMixin } from '~/units/properties/mixins/property.mixin';
import FloorPlan from '~/components/common/FloorPlan.vue';
import NeuronGoogleMap from '~/components/common/NeuronGoogleMap.vue';
import Epc from '~/components/common/Epc.vue';
import NcSelect from '~/components/common/inputs/NcSelect.vue';
import NcInput from '~/components/common/inputs/NcInput.vue';
import NcButton from '~/components/common/inputs/NcButton.vue';
import FullScreenGallery from '~/components/common/FullScreenGallery.vue';
import { useCoreStore } from '~/units/core/store';
import SendLead from '~/components/common/leads/SendLead.vue';
import Success from '~/components/common/popup/Success.vue';
import Popup from '~/components/common/popup/Popup.vue';
import PropertyDetailActions from '~/components/theme5/properties/PropertyDetailActions.vue';
import AvailableComponentsForSidebar from '~/components/theme4/AvailableComponentsForSidebar.vue';
import { FullScreenPopupMixin } from '~/units/core/mixins/fullScreenPopupMixin';
import { getImagesByCount } from '~/units/properties/store';

export default defineNuxtComponent({
  name: 'FormCard',

 mixins: [ComponentMixin, PropertyMixin, FullScreenPopupMixin],

  data() {
    return {
      form: null,
      variants: {
        v1: 'v1',
        v2: 'v2',
       
      },
    };
  },

  created() {
    this.form = this.parseFormV2(this.vars.cardForm);
  },

  computed: {
    variant() {
      return useVariant(this.component);
    },

    buttons() {
      return this.groupedVariables.buttons;
    },

    descriptions() {
      return this.groupedVariables.descriptions;
    },
  },
});
</script>
